module.exports = __webpack_public_path__ + "static/media/poslugi.7f6546ad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/general/poslugi.svg
// module id = 128
// module chunks = 0